import { useMemo } from 'react';
import { generateRandomNumber } from 'framework-listing-lib/internal/utils/numberUtils';
import LoadingSkeleton from 'framework-listing-lib/internal/shared/components/LoadingSkeleton';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { Flex } from 'foundations-components/components/Flex';
import { Spacer } from 'foundations-components/components/Spacer';
import { View } from 'foundations-components/components/View';
import { FileIcon } from 'foundations-assets/icons/components/FileIcon';
import { FolderIcon } from 'foundations-assets/icons/components/FolderIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function FolderListSkeleton({
  total
}) {
  const folderList = useMemo(() => Array.from({
    length: total
  }).map(() => `${generateRandomNumber(30, 80)}`), [total]);
  return /*#__PURE__*/_jsx(View, {
    inlineSize: "100%",
    children: /*#__PURE__*/_jsx(List, {
      paddingInlineStart: "0",
      paddingBlockEnd: "500",
      children: folderList.map((folder, index) => /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          blockSize: "32px",
          padding: "200",
          flexGrow: 1,
          children: [index === 0 ? /*#__PURE__*/_jsx(FileIcon, {
            color: "icon-primary-disabled",
            size: "400"
          }) : /*#__PURE__*/_jsx(FolderIcon, {
            color: "icon-primary-disabled",
            size: "400"
          }), /*#__PURE__*/_jsx(Spacer, {
            space: "0",
            marginInlineEnd: "250",
            display: "inline-block"
          }), /*#__PURE__*/_jsx(LoadingSkeleton, {
            blockSize: "16px",
            inlineSize: `${folder}%`
          })]
        })
      }, index))
    })
  });
}